/* ============================================================
   Disponibilité en retrait

   La disponibilité dépend de la déclinaison : une taille peut être en
   magasin quand une autre ne l'est pas. Le composant se redemande donc
   à Shopify à chaque changement, par la section `pickup-availability`
   plutôt qu'en devinant côté client.
   ============================================================ */
(function () {
  'use strict';

  if (customElements.get('lf-pickup-availability')) return;

  class PickupAvailability extends HTMLElement {
    connectedCallback() {
      this.racine = this.dataset.rootUrl;
      this.ouvrir = this.querySelector('[data-lf-pickup-open]');
      this.tiroir = this.querySelector('[data-lf-pickup-drawer]');
      this.fermer = this.querySelector('[data-lf-pickup-close]');
      this.brancheTiroir();
      this.ecouteVariantes();
    }

    /* Le tiroir ouvert vit dans `body`, pas dans le composant : remplacer
       le contenu de celui-ci ne l'emporte donc pas, et l'ancien restait a
       l'ecran a cote du neuf — deux disponibilites, dont une perimee.
       Mesure sur la fiche : deux `[data-lf-pickup-drawer]` apres un
       changement de declinaison tiroir ouvert. On le retire donc a la
       main, en refermant d'abord son calque pour rendre la page au
       clavier. */
    videTiroir() {
      if (!this.tiroir) return false;
      var avaitLeFocus = this.tiroir.contains(document.activeElement);
      if (window.lfCalque && window.lfCalque.estOuvert(this.tiroir)) {
        window.lfCalque.fermer(this.tiroir);
      }
      this.tiroir.remove();
      this.tiroir = null;
      return avaitLeFocus;
    }

    disconnectedCallback() {
      // Un tiroir sorti vers `body` ne doit pas survivre au composant.
      if (this.tiroir && this.tiroir.parentElement === document.body) this.tiroir.remove();
      if (this.surVariante) {
        document.removeEventListener('lf:variant:change', this.surVariante);
        this.surVariante = null;
      }
      if (this.requete) this.requete.abort();
      document.removeEventListener('keydown', this.echap);
    }

    brancheTiroir() {
      if (!this.ouvrir || !this.tiroir) return;
      this.ouvrir.addEventListener('click', () => {
        /* Le tiroir vivait dans la section produit : son contexte
           d'empilement le plafonnait sous l'en-tete collant, qui recouvrait
           et rognait le haut de la fenetre des qu'elle comptait plusieurs
           magasins. Il passe dans `body` le temps d'etre ouvert. */
        document.body.appendChild(this.tiroir);
        this.tiroir.hidden = false;
        // Focus garde dans le tiroir tant qu'il est ouvert : voir lf-calque.js.
        if (window.lfCalque) window.lfCalque.ouvrir(this.tiroir, { focus: this.fermer || null, retour: this.ouvrir });
        else (this.fermer || this.tiroir).focus();
        document.addEventListener('keydown', this.echap);
      });
      if (this.fermer) {
        this.fermer.addEventListener('click', () => this.ferme());
      }
      this.tiroir.addEventListener('click', (e) => {
        if (e.target === this.tiroir) this.ferme();
      });
    }

    ferme() {
      if (!this.tiroir) return;
      this.tiroir.hidden = true;
      // Il revient dans le composant, que le prochain rechargement remplace.
      if (this.tiroir.parentElement === document.body) this.appendChild(this.tiroir);
      document.removeEventListener('keydown', this.echap);
      if (window.lfCalque && window.lfCalque.estOuvert(this.tiroir)) window.lfCalque.fermer(this.tiroir);
      else if (this.ouvrir) this.ouvrir.focus();
    }

    echap = (e) => {
      if (e.key === 'Escape') this.ferme();
    };

    ecouteVariantes() {
      /* Le composant se recharge en remplacant son propre contenu, ce qui
         rappelle `connectedCallback` : sans cette garde, un ecouteur de plus
         s'ajoutait a chaque changement et la meme requete partait en double,
         puis en triple. */
      if (this.surVariante) return;

      this.surVariante = (e) => {
        var detail = e.detail || {};

        /* Deux sections peuvent piloter des produits differents sur la meme
           page — une fiche produit et un produit mis en avant. Sans cette
           verification, l'une actualisait le retrait de l'autre avec un
           identifiant qui n'est pas le sien. */
        var maSection = this.dataset.sectionId;
        if (maSection && detail.sectionId && detail.sectionId !== maSection) return;

        /* Combinaison inexistante : mieux vaut ne rien montrer que la
           disponibilite de la declinaison precedente. */
        if (detail.indisponible) {
          if (this.requete) this.requete.abort();
          this.videTiroir();
          this.innerHTML = '';
          return;
        }

        var id = detail.variant && detail.variant.id;
        if (id) this.recharge(id);
      };

      document.addEventListener('lf:variant:change', this.surVariante);
    }

    recharge(idVariante) {
      if (!this.racine) return;
      /* Un changement rapide lancait plusieurs requetes : la plus lente
         pouvait repondre en dernier et afficher un etat perime. */
      if (this.requete) this.requete.abort();
      this.requete = new AbortController();

      var url = this.racine + 'variants/' + idVariante + '/?section_id=pickup-availability';
      fetch(url, { signal: this.requete.signal })
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .then((html) => {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var neuf = doc.querySelector('lf-pickup-availability');
          var relancerLeFocus = this.videTiroir();
          if (neuf) {
            this.innerHTML = neuf.innerHTML;
            this.dataset.variantId = idVariante;
            this.connectedCallback();
            /* Le clavier etait dans le tiroir qu'on vient de retirer : on le
               repose sur le bouton qui l'ouvre, plutot que de le laisser
               retomber sur `body` et repartir du haut de la page. */
            if (relancerLeFocus && this.ouvrir) this.ouvrir.focus();
          } else {
            // Plus aucun magasin pour cette déclinaison : on n'affiche rien
            // plutôt qu'un état périmé.
            this.innerHTML = '';
          }
        })
        .catch(() => {
          this.videTiroir();
          this.innerHTML = '';
        });
    }
  }

  customElements.define('lf-pickup-availability', PickupAvailability);
})();
